import type { Language, PreviewDoc, PriceOffer } from "../types";
import type { Words } from "./copy";
import { FromPrice, LateLine } from "./Facts";
import "./rows.css";

/** The price on the first screen, straight under the drawing and before
 *  "Does it look right?".
 *
 *  Thirty to forty-four in a hundred of the people who open the page never
 *  reach the price card, and the number is what they are deciding on. This is
 *  the smallest honest version of it: what the piece starts at, and the date
 *  it is bought against, one tap from the sizes. Nothing here is new to the
 *  page; every word is one the price card says a few screens down.
 *
 *  The date is the server's own sentence and nothing is typed here: the
 *  Christmas line up to the last day to order for it, then the late line (that
 *  Christmas is no longer promised, and that express is a choice at checkout),
 *  and outside the season when it would arrive. So after the last day it turns
 *  into the late line by itself, with no day written in this file.
 *
 *  Only a part of the page's layout test (PageLayout.priceLine): a page not
 *  shown it has the price card, as it always had. A button because it goes
 *  somewhere, which is why its text is spans and not paragraphs. */
export default function PriceLine({
  price,
  delivery,
  language,
  words: t,
}: {
  /** The shown piece's own offer. Nothing without one. */
  price: PriceOffer | null | undefined;
  delivery: PreviewDoc["delivery"] | null | undefined;
  language: Language;
  words: Words;
}) {
  if (!price) return null;
  const when = delivery?.christmas || (delivery?.late ? null : delivery?.arrives) || null;
  return (
    <button
      type="button"
      className="priceline"
      onClick={() => document.getElementById("price")?.scrollIntoView({ behavior: "smooth", block: "start" })}
    >
      <span>
        <FromPrice price={price} words={t} />
      </span>
      {when && <span className="priceline-when">{when}</span>}
      <LateLine delivery={delivery} language={language} card={false} inline style={{ fontSize: 14 }} />
    </button>
  );
}
